import { render, staticRenderFns } from "./PptHelp.vue?vue&type=template&id=22c2baba&"
import script from "./PptHelp.vue?vue&type=script&lang=js&"
export * from "./PptHelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("I:\\web-project\\dream\\tools\\dsf-product-ppt\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22c2baba')) {
      api.createRecord('22c2baba', component.options)
    } else {
      api.reload('22c2baba', component.options)
    }
    module.hot.accept("./PptHelp.vue?vue&type=template&id=22c2baba&", function () {
      api.rerender('22c2baba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "pc/components/PptHelp.vue"
export default component.exports